export default __webpack_public_path__ + "static/media/pinkQuestionCrownToRight.8873a1fd.svg";